module.exports = __webpack_public_path__ + "static/media/slices_heart.22f55abe.jpg";